export interface IUserCreationOptions {
    avatarUrl?: string;
    joinDefaultChannels?: boolean;
    verified?: boolean;
    requirePasswordChange?: boolean;
    sendWelcomeEmail?: boolean;
}
